import { CloseOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import { Alert as AntdAlert, Button } from 'antd';
import React from 'react';

interface MultipleStoreAlertProps {
  onClose?: () => void;
}

export const MultipleStoreAlert: React.FC<MultipleStoreAlertProps> = ({ onClose }) => {
  return (
    <AntdAlert
      message={
        <div className="relative flex items-center gap-6">
          <div className="flex items-start gap-3">
            <ExclamationCircleFilled className="py-1 text-md" style={{ color: '#faad14' }} />
            <div className="flex flex-col">
              <div className="font-semibold text-sm">
                Heads up! You&apos;ve selected items from multiple stores
              </div>
              <div className="text-xs mt-1">
                Each store&apos;s conditions will be checked separately — they won&apos;t combine across stores.
              </div>
            </div>
          </div>
          <div className="flex items-center gap-4 ml-auto">
            <Button type="default" className="rounded-full !border-none p-2" size="middle" onClick={() => window.open('https://help.aspireiq.com/en/articles/8874943-how-to-sync-promo-code-offers-to-multiple-shopify-stores', '_blank')}>Learn More</Button>
            {onClose && (
              <CloseOutlined
                onClick={onClose}
                style={{
                  cursor: 'pointer',
                  fontSize: '12px',
                  color: '#666'
                }}
              />
            )}
          </div>
        </div>
      }
      type="warning"
      showIcon={false}
      style={{
        border: 'none',
        borderRadius: '16px',
        padding: '16px',
        marginBottom: '16px'
      }}
    />
  );
};
